import styled from '@emotion/styled'

import { ReactComponent as CreateFirstInvoiceIllustration } from '../../../../../../assets/dashboard-create-first-invoice.svg'

export const WidgetContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  z-index: 1;
`

export const Header = styled.div``

export const Footer = styled.div``

export const DescriptionWrapper = styled.div`
  width: 65%;
`

export const Illustration = styled(CreateFirstInvoiceIllustration)`
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: -1;
  pointer-events: none;
`
